import { ThemeInterface } from "../interfaces/theme.interface";
import { OrtecTheme } from "./ortec.theme";

export const themes: ThemeInterface[] = [
  OrtecTheme
];